import { Component } from '@angular/core';
import { CompanyInfoService } from '../../Services/company-info.service';
import { AuthService } from '../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from '../../../environments/environment'
import { CustomToastrService } from '../../Shared/Services/custom-toastr.service';
import { DtoCompanyInfoVM } from '../../Model/DtoCompanyInfoVM';
import { SharedService } from '../../Shared/Services/shared.service';
import { DownloadService } from '../../Services/download.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  imgPath: string = environment.ImgUrl;
  CompanyInfo: DtoCompanyInfoVM | undefined;
  ProductsList: any[] = [];
  constructor(private api: CompanyInfoService, private auth: AuthService, private spinner: NgxSpinnerService, private router: Router,
    private toastrService: CustomToastrService, private shared: SharedService, private download: DownloadService) {
    this.ProductsList = [
      {
        img: '/assets/images/door-window.png',
        title: this.shared.getFromTranslateService('DoorsAndWindows')
      },
      {
        img: '/assets/images/accessories.png',
        title: this.shared.getFromTranslateService('Accessories')
      },
      {
        img: '/assets/images/qeta.png',
        title: this.shared.getFromTranslateService('Sectors')
      },
      {
        img: '/assets/images/machines.png',
        title: this.shared.getFromTranslateService('Machines')
      }
    ];
  }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.spinner.show();
      this.GetCompanyInfo();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCompanyInfo() {
    this.api.GetCompanyInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            this.CompanyInfo = res.payload;
            this.spinner.hide();
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }

  DownLoadCompanyFile(file: any) {
    this.shared.downloadFile(file, 'CompanyFile');
  }
}
